import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderVinnytsia(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-vinnytsia/create-distribution-order-vinnytsia",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderVinnytsia(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-vinnytsia/create-distribution-to-order-vinnytsia",
      params,
      callBackFn
    );
  },
  async getVinnytsiaAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-vinnytsia/get-vinnytsia-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
